module.exports = __webpack_public_path__ + "static/media/b6_levels_8-29.098d392b.png";